import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { CustomPixelProvider } from '@/lib/analytics/providers/custom-pixel';

export function usePageTracking(): void {
  const location = useLocation();
  const isFirstRender = useRef(true);
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    // Skip initial load - pixel already fires page on init
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Skip if same path (e.g., only query param or hash changed)
    if (previousPath.current === location.pathname) {
      return;
    }

    previousPath.current = location.pathname;

    // Fire page view for route transition
    CustomPixelProvider.fireRouteChangePage();
  }, [location.pathname]);
}
